import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'components/common/router';
import { Alert, Col, Row } from 'components/bootstrap';
import { IfPermitted } from 'components/common';
import Routes from 'routing/Routes';
import AppConfig from 'util/AppConfig';
import { LicenseStatusPropType } from 'archive/propTypes';
import type { LicenseStatus } from 'archive/types';

const isCloud = AppConfig.isCloud();

const LicenseStatusComponent = () => (
  <Alert bsStyle="danger" title="Instant Archiving is disabled">
    <p>
      Instant Archiving is disabled because there is no valid license.
      You can still restore existing archives, but Graylog will not archive new data.
    </p>
    {isCloud
      ? (<>Contact your Graylog account manager.</>)
      : (
        <IfPermitted permissions="licenses:create">
          <p>
            See <Link to={Routes.pluginRoute('SYSTEM_LICENSES')}>Licenses page</Link> for details.
          </p>
        </IfPermitted>
      )}
  </Alert>
);

type Props = {
  licenseStatus: LicenseStatus,
  summary?: boolean,
  rowClass?: string,
  colWidth?: number,
};

const InstantArchivingLicenseStatus = ({ licenseStatus, summary, rowClass, colWidth }: Props) => {
  const { status, missing } = licenseStatus;

  if (!missing && (status && status.valid)) {
    return null;
  }

  if (summary) {
    return <LicenseStatusComponent />;
  }

  return (
    <Row className={rowClass}>
      <Col md={colWidth}>
        <LicenseStatusComponent />
      </Col>
    </Row>
  );
};

InstantArchivingLicenseStatus.propTypes = {
  licenseStatus: LicenseStatusPropType.isRequired,
  colWidth: PropTypes.number,
  rowClass: PropTypes.string,
  summary: PropTypes.bool,
};

InstantArchivingLicenseStatus.defaultProps = {
  colWidth: 12,
  rowClass: 'content',
  summary: false,
};

export default InstantArchivingLicenseStatus;
